function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatusLocked = function SvgStatusLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    style: {
      fill: "#fff",
      opacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.961 19.046a2.418 2.418 0 0 1-2.427-2.4V8.891a2.412 2.412 0 0 1 2-2.362V3.821a4.969 4.969 0 0 1 9.938 0v2.708a2.412 2.412 0 0 1 2 2.362v7.752a2.418 2.418 0 0 1-2.427 2.4zM2.012 8.891v7.752a.946.946 0 0 0 .949.94h9.077a.947.947 0 0 0 .95-.94V8.891a.946.946 0 0 0-.95-.94H2.961a.945.945 0 0 0-.949.94zm2-5.071v2.668h6.983V3.821a3.492 3.492 0 0 0-6.983 0zm2.647 10.765v-1.216a1.84 1.84 0 1 1 1.633.023v1.193a.816.816 0 0 1-1.633 0z",
    "data-name": "Union 14",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(3.5 2.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7762.271-2943.7h-9.078a2.668 2.668 0 0 1-2.677-2.654v-7.751a2.652 2.652 0 0 1 2-2.564v-2.507a5.2 5.2 0 0 1 5.219-5.17 5.2 5.2 0 0 1 5.219 5.17v2.507a2.652 2.652 0 0 1 2 2.564v7.751a2.668 2.668 0 0 1-2.683 2.654zm-9.078-11.1a.7.7 0 0 0-.7.69v7.751a.7.7 0 0 0 .7.69h9.078a.7.7 0 0 0 .7-.69v-7.751a.7.7 0 0 0-.7-.69zm4.517 7.451a1.068 1.068 0 0 1-1.067-1.065v-1.071a2.061 2.061 0 0 1-1-1.768 2.085 2.085 0 0 1 2.092-2.072 2.084 2.084 0 0 1 2.09 2.072 2.08 2.08 0 0 1-1.048 1.8v1.043a1.067 1.067 0 0 1-1.067 1.061zm-3.219-9.414h6.482v-2.417a3.227 3.227 0 0 0-3.24-3.207 3.229 3.229 0 0 0-3.242 3.207z",
    "data-name": "Union 12 - Outline",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(7777.809 2965.1)"
  }));
};
export default SvgStatusLocked;